import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
	Button,
	Space,
	Modal,
    IconButton,
    MeetingAction,
} from '@components';
import {
	MeetingListItem, MeetingStatuses, RecorderStatusEnum,
} from '@api';

import './MeetingInRecModal.scss';
import { MeetingPauseRecIconModal, MeetingStopRecIconModal, MeetingRecIconModal } from '@icons';
import { calcMeetingRecordTime } from '@common';

interface MeetingInRecModalProps {
	closeModal: () => void,
	meetingInfo: MeetingListItem,
    onMeetingAction: (meeting: MeetingListItem, action: MeetingAction) => void,
}

function MeetingInRecModal(props: MeetingInRecModalProps): JSX.Element {
	const {
		// onSubmit,
		closeModal,
		meetingInfo,
        onMeetingAction,
	} = props;

    const [disableActions, setDisableActions] = useState<boolean>(false);    

    
    const intevalId = useRef(null);
    
    const isMeetingInRecord = useMemo(() => {
        return meetingInfo.status.alias === MeetingStatuses.Record && meetingInfo.recorderStatus == RecorderStatusEnum.Recording;
	}, [meetingInfo.status.alias, meetingInfo.recorderStatus]);
    
    const isMeetingInPaused = useMemo(() => {
        return meetingInfo.status.alias === MeetingStatuses.Record && meetingInfo.recorderStatus == RecorderStatusEnum.Paused;
	}, [meetingInfo.status.alias, meetingInfo.recorderStatus]);

    const [timeElapsed, setTimeElapsed] = useState<string>(calcMeetingRecordTime(meetingInfo.recordedDurationMs, meetingInfo.lastRecordingSpanStartUtc, isMeetingInPaused));

	useEffect(() => {
        setDisableActions(false);
        
        const onTick = () => {
            setTimeElapsed(calcMeetingRecordTime(meetingInfo.recordedDurationMs, meetingInfo.lastRecordingSpanStartUtc, isMeetingInPaused));
        }

        if (meetingInfo.recorderStatus == RecorderStatusEnum.Recording) {
            intevalId.current = setInterval(onTick, 1000);
        }

		return () => {
            if (intevalId.current) {
                clearInterval(intevalId.current);
            }
        }
	}, [meetingInfo, isMeetingInPaused]);

	
	const actionClick = useCallback((ev: React.MouseEvent, action: MeetingAction) => {
        onMeetingAction(meetingInfo, action);
        setDisableActions(true);

        if (intevalId.current) {
            clearInterval(intevalId.current);
        }

        if (action == MeetingAction.stop_recording) {
            closeModal();
        }

	}, [meetingInfo, onMeetingAction, closeModal, setDisableActions]);

	const headerView = useMemo((): JSX.Element => {
		return (
			<div className="meeting-rec-modal__header">
				<Button onClick={closeModal} theme='ghost'>
					Свернуть
				</Button>
			</div>
		);
	}, [closeModal]);


	return (meetingInfo &&
		<Modal
			className="meeting-rec-modal"
			header={headerView}
			isOpen
		>
			<div className="meeting-rec-modal__content">
                <div className='rec_title'>Идёт собрание</div>
                <div className='rec_subtitle'>{meetingInfo.subject}</div>
                <div className='rec_time'>{timeElapsed}</div>
                    {isMeetingInRecord ?
                    <Space className='rec_actions'>
                        <IconButton
                            disabled={disableActions}
                            icon={<MeetingPauseRecIconModal />}
                            iconSize="32px"
                            size="nogap" 
                            onClick={(e) => actionClick(e, MeetingAction.pause_recording)}
                        />
                        <IconButton
                            disabled={disableActions}
                            icon={<MeetingStopRecIconModal />}
                            iconSize="32px"
                            size="nogap" 
                            onClick={(e) => actionClick(e, MeetingAction.stop_recording)}
                        />
                    </Space>
                    :null}
                    {isMeetingInPaused ?
                    <Space className='rec_actions'>
                        <IconButton
                            disabled={disableActions}
                            icon={<MeetingRecIconModal />}
                            iconSize="32px"
                            size="nogap" 
                            onClick={(e) => actionClick(e, MeetingAction.resume_recording)}
                        />
                        <IconButton
                            disabled={disableActions}
                            icon={<MeetingStopRecIconModal />}
                            iconSize="32px"
                            size="nogap" 
                            onClick={(e) => actionClick(e, MeetingAction.stop_recording)}
                        />
                    </Space>
                    :null}
			</div>
		</Modal>
	);
}

export { MeetingInRecModal };